export default __webpack_public_path__ + "static/media/guia-1-1.568dfb2c.svg";